import { INavItem } from "src/components/layouts";

export const
    ToggleNavigationDrawer: IToggleNavigationDrawerActionCreator = (isOpen) => {
        return {
            type: ACTION_TOGGLE_NAVIGATION_DRAWER,
            isOpen
        }
    },

    Clear: INavigationDrawerClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_NAVIGATION_DRAWER_CLEAR,
            propertiesToClear
        }
    },

    SetDrawerItems: ISetDrawerItemsActionCreator = (drawerItems) => {
        return {
            type: ACTION_SET_DRAWER_ITEMS,
            drawerItems
        }
    },

    SetBreadcrumbs: ISetBreadcrumbsActionCreator = (breadcrumbs) => {
        return {
            type: ACTION_SET_BREADCRUMBS,
            breadcrumbs
        }
    },

    ClearBreadcrumbs: IClearBreadcrumbsActionCreator = () => {
        return {
            type: ACTION_CLEAR_BREADCRUMBS
        }
    };



export const
    ACTION_TOGGLE_NAVIGATION_DRAWER = "ACTION_TOGGLE_NAVIGATION_DRAWER",

    ACTION_NAVIGATION_DRAWER_CLEAR = "ACTION_NAVIGATION_DRAWER_CLEAR",

    ACTION_SET_DRAWER_ITEMS = "ACTION_SET_DRAWER_ITEMS",

    ACTION_SET_BREADCRUMBS = "ACTION_SET_BREADCRUMBS",

    ACTION_CLEAR_BREADCRUMBS = "ACTION_CLEAR_BREADCRUMBS";

export interface IToggleNavigationDrawerAction {
    type: "ACTION_TOGGLE_NAVIGATION_DRAWER";
    isOpen: boolean;
}

export interface IToggleNavigationDrawerActionCreator {
    (isOpen: boolean): IToggleNavigationDrawerAction;
}

export interface INavigationDrawerClearAction {
    type: "ACTION_NAVIGATION_DRAWER_CLEAR";
    propertiesToClear?: string[];
}

export interface INavigationDrawerClearActionCreator {
    (propertiesToClear?: string[]): INavigationDrawerClearAction;
}

export interface ISetDrawerItemsAction {
    type: "ACTION_SET_DRAWER_ITEMS";
    drawerItems: INavItem[];

}

export interface ISetDrawerItemsActionCreator {
    (drawerItems: INavItem[]): ISetDrawerItemsAction;
}

export interface ISetBreadcrumbsAction {
    type: "ACTION_SET_BREADCRUMBS";
    breadcrumbs: INavItem[];

}

export interface ISetBreadcrumbsActionCreator {
    (breadCrumbs: INavItem[]): ISetBreadcrumbsAction;
}

export interface IClearBreadcrumbsAction {
    type: "ACTION_CLEAR_BREADCRUMBS";

}

export interface IClearBreadcrumbsActionCreator {
    (): IClearBreadcrumbsAction;
}

export type NavigationDrawerAction =
    IToggleNavigationDrawerAction |
    INavigationDrawerClearAction |
    ISetDrawerItemsAction |
    ISetBreadcrumbsAction |
    IClearBreadcrumbsAction;
